export const PAGE_SIZE = 8;

export const formatPeriodo = (periodo: string) => {
	const [ano, mes] = periodo.split('-');
	if (!ano || !mes) return periodo;
	return `${mes}/${ano}`;
};

export const formatDate = (value: string) => {
	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return value;
	return date.toLocaleDateString('pt-BR');
};

export const parseComissao = (texto: string) => {
	const digitos = texto.replace(/\D/g, '');
	if (!digitos) return null;
	const valor = Number(digitos) / 100;
	return Number.isFinite(valor) ? valor : null;
};

export const comissaoValida = (valor: number | null): valor is number =>
	valor !== null && valor >= 0 && valor <= 999999.99;

export const parseQuantidadeOpcional = (texto: string) => {
	const valor = texto.trim();
	if (!valor) return null;
	if (!/^\d+$/.test(valor)) return Number.NaN;
	return Number(valor);
};

export const quantidadeOpcionalValida = (valor: number | null) =>
	valor === null || (Number.isInteger(valor) && valor >= 1);

export const textoStatusSolicitacao: Record<string, string> = {
	SOLICITADA: 'Aguardando análise',
	ACEITA: 'Aceita',
	RECUSADA: 'Recusada',
	CANCELADA: 'Cancelada',
};

export const corStatusSolicitacao: Record<string, { color: string; bgcolor: string }> = {
	SOLICITADA: { color: 'rgb(180, 83, 9)', bgcolor: 'rgba(180, 83, 9, 0.12)' },
	ACEITA: { color: 'rgb(5, 150, 105)', bgcolor: 'rgba(5, 150, 105, 0.12)' },
	RECUSADA: { color: 'rgb(220, 38, 38)', bgcolor: 'rgba(220, 38, 38, 0.12)' },
	CANCELADA: { color: 'rgb(100, 116, 139)', bgcolor: '#f1f5f9' },
};

export const withAlpha = (color: string, alpha: number) => {
	if (color.startsWith('rgb(')) {
		return color.replace('rgb(', 'rgba(').replace(')', `, ${alpha})`);
	}
	const clean = color.replace('#', '');
	const normalized =
		clean.length === 3
			? clean
					.split('')
					.map((char) => char + char)
					.join('')
			: clean;
	const value = Number.parseInt(normalized, 16);
	if (Number.isNaN(value)) return `rgba(254, 102, 0, ${alpha})`;
	const r = (value >> 16) & 255;
	const g = (value >> 8) & 255;
	const b = value & 255;
	return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
